import React from 'react';
import { openFranchiseFinmodelForm } from './franchiseConstants';

export function EconomyNewSection() {
  return (
    <section id="s-economy-new" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-economy-new" data-reveal>
          <div className="franchise-economy-new__background"> </div>
          <img className="franchise-economy-new__boxes" src="/assets/media/franchise/economy-section/boxes.png" alt="Коробки" />
          <div className="franchise-economy-new__banner">ЭКОНОМИКА <br /> ФРАНШИЗЫ <br /> В ЦИФРАХ</div>
          <div className="franchise-economy-new__body">
            <div className="franchise-economy-new__body__box">
              <span>Инвестиции</span>
              <div>1,6 – 2,8 млн. ₽</div>
            </div>
            <div className="franchise-economy-new__body__box">
              <span>Прибыль</span>
              <div>от 345 тыс. ₽</div>
            </div>
            <div className="franchise-economy-new__body__box">
              <span>Окупаемость</span>
              <div>6 – 12 месяцев</div>
            </div>
            <div className="franchise-economy-new__body__box">
              <span>Средний чек</span>
              <div>1333 ₽ – 1810 ₽</div>
            </div>
          </div>
          <div className="franchise-economy-new__button">
            <div className="franchise-economy-new__button__background"> </div>
            <button type="button" onClick={openFranchiseFinmodelForm()}>
              Получить финансовую модель
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
